// BookingContext.js - Updated
import React, { createContext, useContext, useState } from 'react';

const BookingContext = createContext();

export const BookingProvider = ({ children }) => {
  const [bookingData, setBookingData] = useState({
    // Form Data
    tripType: 'LOCAL',
    from: '',
    to: '',
    city: '',
    pickupDate: new Date().toISOString().split('T')[0],
    returnDate: new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    pickupTime: '08:00',
    tripDirection: 'Drop to Airport',
    pickupAddress: '',
    dropAirport: '',
    rentalPackage: '',
    
    // Vehicle Selection
    selectedVehicle: null,
    totalPrice: 0,
    
    // Contact Details
    name: '',
    email: '',
    mobile: '',
    specialInstructions: '',
    
    // Additional fields
    pickupLocation: '',
    mobileNumber: '',
    serviceType: '',
    service: '',
    terminal: '',
    flightNumber: '',
    fromCity: '',
    toCity: '',
    submittedAt: ''
  });

  const updateBookingData = (newData) => {
    setBookingData(prev => ({ ...prev, ...newData }));
  };

  return (
    <BookingContext.Provider value={{ 
      bookingData, 
      setBookingData, // Add this line
      updateBookingData 
    }}>
      {children}
    </BookingContext.Provider>
  );
};

export const useBooking = () => {
  const context = useContext(BookingContext);
  if (!context) {
    throw new Error('useBooking must be used within BookingProvider');
  }
  return context;
};